module.exports = __webpack_public_path__ + "static/img/7f4ff6b76c04c572f592d42e30703579.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUsBanner.jpg
// module id = fP+q
// module chunks = 1